import { Component, Input, OnInit, OnChanges, HostBinding, Output, EventEmitter, SimpleChanges} from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { SolutionService } from '../../service/solution.service';

@Component({
    selector: 'app-filter-search',
    templateUrl: './search.component.html'
})

export class SearchComponent implements OnInit,OnChanges{
   
    /**
     * QueryCondition类型
     */
    @Input() item:any;
    @Input() autoLabel:boolean;
    @Input() disabled:boolean;
    @Output('searchHandle') searchHandle = new EventEmitter();

    /**判断是否是在扩展区域展示 */
    extend:boolean = false;
    /**判断是否显示label */
    showlabel:boolean = true;
    placeholder: string;

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }

    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }

    groupIcon = '<span class="k-icon k-i-search"></span>';

    constructor(private solutionService:SolutionService){}

    ngOnInit(): void {
        if(this.item){
            const type = Object.prototype.toString.call(this.item.placeHolder);
            if(type == '[object Undefined]'){
                if(this.item.control && this.item.control.hasOwnProperty('placeholder')){
                    this.placeholder = this.item.control.placeholder;
                }
            }
            else{
                this.placeholder = this.item.placeHolder;
            }
        }
        if(this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')){
            this.extend = this.item.control.isExtend;
            if(!this.extend){
                this.showlabel = this.item.control.showLabel;
            }
        }

        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);
    }

    ngOnChanges(changes: SimpleChanges): void {
       
    }

    // getConditionItemStyle(field: QueryCondition, controlType: any) {
    //     return this.solutionService.getConditionItemStyle(field,controlType);
    // }

    getConditionItemTitle(field:QueryCondition){
        return this.solutionService.getConditionItemTitle(field);
    }

    onSearch($event){
        if(this.disabled){return;}
        this.searchHandle.emit($event);
    }
}